import React, { useState, useEffect, useCallback, useMemo } from 'react';

const STATUS = {
  realizada:   { label:'Realizada',   icon:'✅', color:'#0b8043', bg:'#e6f4ea', border:'#34a853' },
  falta:       { label:'Falta',       icon:'❌', color:'#c5221f', bg:'#fce8e6', border:'#ea4335' },
  cancelou:    { label:'Cancelou',    icon:'📅', color:'#e37400', bg:'#fef7e0', border:'#fbbc04' },
  recuperacao: { label:'Recuperação', icon:'🔄', color:'#d56e0c', bg:'#fdebd0', border:'#f09300' },
};

const SEM_STATUS_COR = '#4285f4';
const SEM_STATUS_BG  = '#e8f0fe';
const SEM_STATUS_TXT = '#1a73e8';

const DIAS  = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

const localDate = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
};
const fmtHora = (iso) => {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
};
const fmtDataLonga = (iso) => {
  const d = new Date(iso);
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]}`;
};

// ── Painel de detalhes ────────────────────────────────────────────────────────
const PainelAluno = ({ registro, onStatus, onClose, isMobile }) => {
  const [step, setStep]          = useState('main');
  const [justificada, setJustif] = useState(null);
  const [cobrar, setCobrar]      = useState(false);
  const [reposicao, setRepos]    = useState(false);
  const [obs, setObs]            = useState(registro.observacao || '');

  const cfg = registro.status ? STATUS[registro.status] : null;

  const salvar = (status, extra = {}) =>
    onStatus(registro, status, { observacao: obs || null, ...extra });

  const confirmarFalta = () => {
    if (justificada === null) { alert('Selecione o tipo de falta'); return; }
    salvar('falta', { falta_justificada: justificada, cobrar_aula: cobrar, liberar_reposicao: reposicao });
  };

  const panelStyle = isMobile
    ? { position:'fixed', bottom:0, left:0, right:0, zIndex:4001, background:'white',
        borderRadius:'20px 20px 0 0', boxShadow:'0 -4px 24px rgba(0,0,0,0.18)',
        padding:'0 20px 32px', maxHeight:'92vh', overflowY:'auto' }
    : { position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', zIndex:4001,
        background:'white', borderRadius:'16px', boxShadow:'0 8px 40px rgba(0,0,0,0.22)',
        padding:'28px', width:'420px', maxWidth:'94vw', maxHeight:'90vh', overflowY:'auto' };

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(32,33,36,0.4)', zIndex:4000 }} />
      <div style={panelStyle}>
        {isMobile && <div style={{ width:'36px', height:'4px', background:'#dadce0', borderRadius:'2px', margin:'14px auto 20px' }} />}

        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'16px' }}>
          <div>
            <div style={{ fontSize:'17px', fontWeight:700, color:'#202124' }}>👤 {registro.aluno_nome}</div>
            <div style={{ fontSize:'13px', color:'#70757a', marginTop:'3px' }}>
              {fmtDataLonga(registro.data_hora)} · {fmtHora(registro.data_hora)}
            </div>
            <div style={{ fontSize:'12px', color:'#9aa0a6', marginTop:'1px' }}>{registro.aluno_email}</div>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'22px', color:'#70757a', cursor:'pointer', padding:'0 0 0 14px', lineHeight:1, flexShrink:0 }}>✕</button>
        </div>

        {/* Badge status atual */}
        {cfg && (
          <div style={{ marginBottom:'16px', padding:'10px 14px', borderRadius:'10px', background:cfg.bg, border:`1px solid ${cfg.border}`, display:'flex', alignItems:'center', gap:'8px', flexWrap:'wrap' }}>
            <span style={{ fontSize:'16px' }}>{cfg.icon}</span>
            <span style={{ fontWeight:700, color:cfg.color, fontSize:'14px' }}>{cfg.label}</span>
            {registro.status === 'falta' && registro.falta_justificada !== null && (
              <span style={{ fontSize:'12px', color:cfg.color, opacity:0.8 }}>
                · {registro.falta_justificada ? 'Justificada' : 'Não justificada'}
              </span>
            )}
            {registro.status === 'falta' && (registro.cobrar_aula || registro.liberar_reposicao) && (
              <div style={{ display:'flex', gap:'6px', flexWrap:'wrap', marginTop:'4px', width:'100%' }}>
                {registro.cobrar_aula       && <span style={{ fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:'#fef7e0', color:'#e37400', fontWeight:600 }}>💰 Cobrar aula</span>}
                {registro.liberar_reposicao && <span style={{ fontSize:'11px', padding:'2px 8px', borderRadius:'10px', background:SEM_STATUS_BG, color:SEM_STATUS_TXT, fontWeight:600 }}>🔄 Reposição liberada</span>}
              </div>
            )}
          </div>
        )}

        {step === 'main' && (
          <>
            <p style={{ fontSize:'11px', fontWeight:600, color:'#70757a', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'10px' }}>Marcar como:</p>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px', marginBottom:'20px' }}>
              {Object.entries(STATUS).map(([key, s]) => {
                const ativo = registro.status === key;
                return (
                  <button key={key} onClick={() => key === 'falta' ? setStep('falta') : salvar(key)} style={{
                    display:'flex', alignItems:'center', gap:'8px', padding:'11px 12px',
                    borderRadius:'10px', cursor:'pointer', fontSize:'13px',
                    border:`2px solid ${ativo ? s.border : '#dadce0'}`,
                    background: ativo ? s.bg : 'white',
                    color: ativo ? s.color : '#3c4043',
                    fontWeight: ativo ? 700 : 400,
                    transition:'all 0.12s ease',
                  }}>
                    <span style={{ fontSize:'16px' }}>{s.icon}</span> {s.label}
                  </button>
                );
              })}
            </div>

            <p style={{ fontSize:'11px', fontWeight:600, color:'#70757a', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'8px' }}>Observação:</p>
            <textarea
              value={obs}
              onChange={e => setObs(e.target.value)}
              placeholder="Adicione uma observação (opcional)..."
              rows={3}
              style={{ width:'100%', padding:'10px 12px', border:'1px solid #dadce0', borderRadius:'8px', fontSize:'14px', resize:'none', outline:'none', boxSizing:'border-box', fontFamily:'inherit', color:'#202124', lineHeight:1.5 }}
            />
            {obs !== (registro.observacao || '') && registro.status && (
              <button onClick={() => salvar(registro.status)} style={{
                marginTop:'8px', padding:'10px 0', border:'none', borderRadius:'8px',
                background:'#1a73e8', color:'white', fontWeight:600, fontSize:'14px', cursor:'pointer', width:'100%'
              }}>
                Salvar observação
              </button>
            )}
          </>
        )}

        {step === 'falta' && (
          <>
            <p style={{ fontSize:'13px', fontWeight:600, color:'#3c4043', marginBottom:'10px' }}>Tipo de falta:</p>
            {[
              { value:true,  label:'Falta justificada' },
              { value:false, label:'Falta não justificada' },
            ].map(opt => (
              <label key={String(opt.value)} style={{
                display:'flex', alignItems:'center', gap:'10px', cursor:'pointer',
                padding:'12px 14px', borderRadius:'10px', marginBottom:'8px',
                border:`2px solid ${justificada === opt.value ? '#ea4335' : '#dadce0'}`,
                background: justificada === opt.value ? '#fce8e6' : 'white', fontSize:'14px',
              }}>
                <input type="radio" name="justificada" style={{ accentColor:'#ea4335', width:'17px', height:'17px' }}
                  checked={justificada === opt.value} onChange={() => setJustif(opt.value)} />
                <span style={{ fontWeight: justificada === opt.value ? 600 : 400 }}>{opt.label}</span>
              </label>
            ))}

            <p style={{ fontSize:'13px', fontWeight:600, color:'#3c4043', margin:'14px 0 10px' }}>Ações adicionais:</p>
            {[
              { k:'cobrar', v:cobrar, set:setCobrar, label:'Cobrar aula' },
              { k:'repos',  v:reposicao, set:setRepos, label:'Liberar reposição' },
            ].map(opt => (
              <label key={opt.k} style={{
                display:'flex', alignItems:'center', gap:'10px', cursor:'pointer',
                padding:'11px 14px', borderRadius:'10px', marginBottom:'8px',
                border:`1px solid ${opt.v ? '#4285f4' : '#dadce0'}`,
                background: opt.v ? SEM_STATUS_BG : 'white', fontSize:'14px',
              }}>
                <input type="checkbox" style={{ accentColor:'#1a73e8', width:'17px', height:'17px' }}
                  checked={opt.v} onChange={e => opt.set(e.target.checked)} />
                <span style={{ fontWeight: opt.v ? 600 : 400 }}>{opt.label}</span>
              </label>
            ))}

            <div style={{ display:'flex', gap:'8px', marginTop:'20px' }}>
              <button onClick={() => setStep('main')} style={{ flex:1, padding:'11px', border:'1px solid #dadce0', borderRadius:'8px', background:'white', color:'#3c4043', fontWeight:600, cursor:'pointer', fontSize:'14px' }}>
                ← Voltar
              </button>
              <button onClick={confirmarFalta} style={{ flex:2, padding:'11px', border:'none', borderRadius:'8px', background:'#ea4335', color:'white', fontWeight:700, cursor:'pointer', fontSize:'14px' }}>
                Confirmar Falta
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

// ── Bloco de evento no grid ───────────────────────────────────────────────────
const EventoGrid = ({ r, onClick, compacto, isSaving }) => {
  const cfg = r.status ? STATUS[r.status] : null;
  const partes = r.aluno_nome.split(' ');
  const nome = partes.length > 1 ? `${partes[0]} ${partes[1][0]}.` : partes[0];
  const isFixo = r.agendamento_id === null;
  const baseFilter = isFixo ? 'brightness(0.85)' : 'none';
  return (
    <div onClick={() => !isSaving && onClick(r)} title={r.aluno_nome}
      style={{ position:'relative', background: cfg ? cfg.bg : SEM_STATUS_BG, borderLeft:`3px solid ${cfg ? cfg.border : SEM_STATUS_COR}`, borderRadius:'4px', padding: compacto ? '2px 5px' : '4px 7px', marginBottom:'2px', cursor: isSaving ? 'default' : 'pointer', userSelect:'none', minHeight: compacto ? '20px' : '26px', display:'flex', alignItems:'center', gap:'4px', overflow:'hidden', opacity: isSaving ? 0.7 : 1, filter: baseFilter }}
      onMouseEnter={e => !isSaving && (e.currentTarget.style.filter = isFixo ? 'brightness(0.78)' : 'brightness(0.94)')}
      onMouseLeave={e =>  (e.currentTarget.style.filter = baseFilter)}
    >
      {isSaving
        ? <span style={{ fontSize:'10px', flexShrink:0, animation:'spin-slow 0.8s linear infinite', display:'inline-block' }}>⏳</span>
        : cfg && <span style={{ fontSize:'10px', flexShrink:0 }}>{cfg.icon}</span>
      }
      <span style={{ fontSize: compacto ? '11px' : '12px', fontWeight:600, color: cfg ? cfg.color : SEM_STATUS_TXT, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
        {nome}
      </span>
    </div>
  );
};

// ── Componente principal ──────────────────────────────────────────────────────
export const ControleFrequencia = ({ createApi, isMobile, periodo, dataReferencia, setDataReferencia, onRefresh }) => {
  const [registros, setRegistros]     = useState([]);
  const [loading, setLoading]         = useState(false);
  const [salvando, setSalvando]       = useState({});
  const [selecionado, setSelecionado] = useState(null);
  const [subAba, setSubAba]           = useState('semana');
  const [mobileDia, setMobileDia]     = useState(null); // eslint-disable-line no-unused-vars
  const [resumo, setResumo]           = useState(null);
  const [mes, setMes]                 = useState(new Date().getMonth() + 1);
  const [ano, setAno]                 = useState(new Date().getFullYear());
  const [loadingResumo, setLoadingResumo] = useState(false);
  const [notif, setNotif]             = useState(null);

  const toast = useCallback((tipo, msg) => {
    setNotif({ tipo, msg });
    setTimeout(() => setNotif(null), 3500);
  }, []);

  const carregar = useCallback(async () => {
    if (!periodo) return;
    setLoading(true);
    try {
      const api = createApi();
      const inicio = localDate(periodo.inicio);
      const fimD = new Date(periodo.fim);
      fimD.setDate(fimD.getDate() - 1);
      const { data } = await api.get(`/admin/frequencia?data_inicio=${inicio}&data_fim=${localDate(fimD)}`);
      setRegistros(data);
    } catch {
      toast('error', 'Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }, [periodo, createApi, toast]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { setMobileDia(null); }, [periodo?.inicio?.getTime()]);

  const salvarStatus = useCallback(async (registro, status, extra = {}) => {
    const { vaga_id, aluno_id } = registro;
    const key = `${vaga_id}_${aluno_id}`;
    setSalvando(p => ({ ...p, [key]: true }));
    setSelecionado(null);
    try {
      const api = createApi();
      const obsAtual = registros.find(r => r.vaga_id === vaga_id && r.aluno_id === aluno_id)?.observacao ?? null;
      const { data } = await api.post(`/admin/frequencia/vaga/${vaga_id}/aluno/${aluno_id}`, {
        status,
        observacao:        extra.observacao !== undefined ? extra.observacao : obsAtual,
        falta_justificada: extra.falta_justificada  ?? null,
        cobrar_aula:       extra.cobrar_aula        ?? false,
        liberar_reposicao: extra.liberar_reposicao  ?? false,
      });
      const reg = data.registro;
      setRegistros(prev => prev.map(r =>
        r.vaga_id === vaga_id && r.aluno_id === aluno_id
          ? { ...r, status: reg.status, falta_justificada: reg.falta_justificada, cobrar_aula: reg.cobrar_aula, liberar_reposicao: reg.liberar_reposicao, observacao: reg.observacao, registro_id: reg.id }
          : r
      ));
      toast('success', `${STATUS[status].icon} ${STATUS[status].label} salvo!`);
    } catch (err) {
      toast('error', err.response?.data?.error || 'Erro ao salvar');
    } finally {
      setSalvando(p => { const s = { ...p }; delete s[key]; return s; });
    }
  }, [createApi, registros, toast]);

  const { dias, horarios, grid } = useMemo(() => {
    const diasMap = {}, horariosSet = new Set(), grid = {};
    const hoje = localDate(new Date());
    registros.forEach(r => {
      const d = new Date(r.data_hora);
      const dayKey = localDate(d);
      const hora = fmtHora(r.data_hora);
      const cellKey = `${dayKey}_${hora}`;
      if (!diasMap[dayKey]) diasMap[dayKey] = { key: dayKey, data: d, isToday: dayKey === hoje };
      horariosSet.add(hora);
      if (!grid[cellKey]) grid[cellKey] = [];
      grid[cellKey].push(r);
    });
    return {
      dias: Object.values(diasMap).sort((a, b) => a.key.localeCompare(b.key)),
      horarios: [...horariosSet].sort(),
      grid,
    };
  }, [registros]);

  // Stats por dia — para mini-barra colorida nas abas e progresso
  const dayStats = useMemo(() => {
    const result = {};
    dias.forEach(dia => {
      const alunos = Object.entries(grid)
        .filter(([k]) => k.startsWith(dia.key))
        .flatMap(([, v]) => v);
      result[dia.key] = {
        total:         alunos.length,
        realizadas:    alunos.filter(r => r.status === 'realizada').length,
        faltas:        alunos.filter(r => r.status === 'falta').length,
        cancelamentos: alunos.filter(r => r.status === 'cancelou').length,
        recuperacoes:  alunos.filter(r => r.status === 'recuperacao').length,
        sem:           alunos.filter(r => !r.status).length,
      };
    });
    return result;
  }, [dias, grid]);

  useEffect(() => {
    if (dias.length > 0 && !mobileDia)
      setMobileDia((dias.find(d => d.isToday) || dias[0]).key);
  }, [dias, mobileDia]);

  const diaSelecionado = useMemo(() => dias.find(d => d.key === mobileDia) ?? null, [dias, mobileDia]);

  const stats = useMemo(() => {
    const c = { total: registros.length, sem: 0 };
    Object.keys(STATUS).forEach(k => { c[k] = 0; });
    registros.forEach(r => { if (!r.status) c.sem++; else c[r.status]++; });
    return c;
  }, [registros]);

  const carregarResumo = useCallback(async () => {
    setLoadingResumo(true);
    try {
      const api = createApi();
      const { data } = await api.get(`/admin/frequencia/resumo-mensal?mes=${mes}&ano=${ano}`);
      setResumo(data);
    } catch {
      toast('error', 'Erro ao carregar resumo');
    } finally {
      setLoadingResumo(false);
    }
  }, [createApi, mes, ano, toast]);

  useEffect(() => { if (subAba === 'resumo') carregarResumo(); }, [subAba, carregarResumo]);

  const navSemana = (delta) => {
    const base = dataReferencia ? new Date(dataReferencia + 'T12:00:00') : new Date();
    base.setDate(base.getDate() + delta * 7);
    setDataReferencia(base.toISOString().split('T')[0]);
  };

  const irHoje = () => {
    if (dataReferencia === '') { if (onRefresh) onRefresh(); }
    else setDataReferencia('');
  };

  const navMes = (delta) => {
    const d = new Date(ano, mes - 1 + delta, 1);
    setMes(d.getMonth() + 1);
    setAno(d.getFullYear());
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div style={{ fontFamily:"'Google Sans','Roboto','Helvetica Neue',sans-serif", display:'flex', flexDirection:'column', height:'100%', background:'white' }}>
      <style>{`
        @keyframes gcal-toast { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin-slow  { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
      `}</style>

      {/* Toast */}
      {notif && (
        <div style={{ position:'fixed', top:'20px', right:'20px', padding:'12px 20px', borderRadius:'8px', fontWeight:500, zIndex:9999, fontSize:'14px', background:'#323232', color:'white', boxShadow:'0 4px 12px rgba(0,0,0,0.3)', display:'flex', alignItems:'center', gap:'10px', animation:'gcal-toast 0.2s ease' }}>
          {notif.tipo === 'success' ? '✅' : '❌'} {notif.msg}
        </div>
      )}

      {/* Painel detalhe */}
      {selecionado && (
        <PainelAluno
          registro={selecionado}
          onStatus={(id, status, extra) => salvarStatus(id, status, extra)}
          onClose={() => setSelecionado(null)}
          isMobile={isMobile}
        />
      )}

      {/* ── Sub-abas ── */}
      <div style={{ display:'flex', alignItems:'center', gap:'4px', padding: isMobile ? '6px 12px 0' : '10px 20px 0', borderBottom:'1px solid #e0e0e0', background:'white', flexWrap:'wrap' }}>
        {[
          { id:'semana', label: isMobile ? '📅 Semana' : '📅 Visão Semanal' },
          { id:'resumo', label: isMobile ? '📊 Resumo' : '📊 Resumo Mensal' },
        ].map(t => (
          <button key={t.id} onClick={() => setSubAba(t.id)} style={{
            padding: isMobile ? '7px 14px' : '8px 18px', borderRadius:'20px', border:'none', cursor:'pointer',
            fontSize: isMobile ? '13px' : '14px', fontWeight: subAba === t.id ? 600 : 400,
            background: subAba === t.id ? SEM_STATUS_BG : 'transparent',
            color: subAba === t.id ? SEM_STATUS_TXT : '#5f6368',
            transition:'all 0.12s ease',
          }}>
            {t.label}
          </button>
        ))}

        {/* Mini-stats da semana */}
        {subAba === 'semana' && !loading && stats.total > 0 && (
          <div style={{ marginLeft:'auto', display:'flex', gap:'5px', flexWrap:'wrap', alignItems:'center' }}>
            {Object.entries(STATUS).map(([k, s]) => stats[k] > 0 && (
              <span key={k} style={{ fontSize:'12px', padding:'3px 9px', borderRadius:'20px', background:s.bg, color:s.color, fontWeight:600 }}>{s.icon} {stats[k]}</span>
            ))}
            {stats.sem > 0 && (
              <span style={{ fontSize:'12px', padding:'3px 9px', borderRadius:'20px', background:SEM_STATUS_BG, color:SEM_STATUS_TXT, fontWeight:600 }}>⏳ {stats.sem}</span>
            )}
          </div>
        )}
      </div>

      {/* ══ ABA SEMANA ══════════════════════════════════════════════════════════ */}
      {subAba === 'semana' && (
        <div style={{ display:'flex', flexDirection:'column', flex:1, overflow:'hidden' }}>

          {/* Toolbar navegação */}
          <div style={{ display:'flex', alignItems:'center', gap:'6px', padding: isMobile ? '8px 12px' : '10px 20px', borderBottom:'1px solid #e0e0e0', background:'white', flexShrink:0, flexWrap:'wrap' }}>
            <button onClick={irHoje} style={{ padding:'8px 18px', border:'1px solid #dadce0', borderRadius:'20px', background:'white', color:'#3c4043', fontWeight:600, fontSize:'14px', cursor:'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background='#f8f9fa'} onMouseLeave={e => e.currentTarget.style.background='white'}>
              Hoje
            </button>
            {[['◀', -1], ['▶', 1]].map(([l, d]) => (
              <button key={l} onClick={() => navSemana(d)} style={{ width:'36px', height:'36px', borderRadius:'50%', border:'none', background:'none', color:'#70757a', fontSize:'16px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}
                onMouseEnter={e => e.currentTarget.style.background='#f1f3f4'} onMouseLeave={e => e.currentTarget.style.background='none'}>
                {l}
              </button>
            ))}
            {!isMobile && periodo && (
              <span style={{ fontSize:'18px', fontWeight:400, color:'#202124' }}>
                {`${localDate(periodo.inicio).split('-').reverse().join('/')} – ${localDate(new Date(periodo.fim.getTime()-1)).split('-').reverse().join('/')}`}
              </span>
            )}
            <button onClick={carregar} title="Atualizar" style={{ marginLeft:'auto', width:'36px', height:'36px', borderRadius:'50%', border:'none', background:'none', color:'#70757a', fontSize:'18px', cursor:'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background='#f1f3f4'} onMouseLeave={e => e.currentTarget.style.background='none'}>
              🔄
            </button>
          </div>

          {loading ? (
            <div style={{ display:'flex', flex:1, alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'16px', color:'#70757a' }}>
              <div style={{ fontSize:'36px', animation:'spin-slow 2s linear infinite' }}>⏳</div>
              <span style={{ fontSize:'16px' }}>Carregando...</span>
            </div>
          ) : registros.length === 0 ? (
            <div style={{ display:'flex', flex:1, alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'12px', color:'#70757a' }}>
              <span style={{ fontSize:'64px', opacity:0.25 }}>📋</span>
              <p style={{ fontSize:'16px', fontWeight:500 }}>Nenhum aluno agendado nesta semana</p>
            </div>
          ) : (

            /* ══ GRID GCal — desktop e mobile (scroll horizontal) ═════════ */
            <div style={{ flex:1, overflow:'auto', WebkitOverflowScrolling:'touch' }}>
              <table style={{
                width: isMobile ? `max(100%, ${52 + dias.length * 88}px)` : '100%',
                borderCollapse:'collapse', tableLayout:'fixed',
              }}>
                <colgroup>
                  <col style={{ width: isMobile ? '48px' : '56px' }} />
                  {dias.map(d => <col key={d.key} style={{ minWidth: isMobile ? '88px' : undefined }} />)}
                </colgroup>
                <thead style={{ position:'sticky', top:0, zIndex:10, background:'white' }}>
                  <tr>
                    {/* canto top-left sticky */}
                    <th style={{
                      position:'sticky', left:0, zIndex:11, background:'white',
                      borderBottom:'1px solid #e0e0e0', borderRight:'1px solid #e0e0e0', padding:'8px 0',
                    }} />
                    {dias.map(dia => {
                      const ds = dayStats[dia.key] || {};
                      const registrados = ds.total - (ds.sem || 0);
                      const pct = ds.total > 0 ? Math.round(registrados / ds.total * 100) : 0;
                      return (
                        <th key={dia.key} style={{ padding:'6px 4px 6px', borderBottom:'1px solid #e0e0e0', borderRight:'1px solid #e0e0e0', textAlign:'center', fontWeight:400 }}>
                          <div style={{ fontSize:'11px', color:'#70757a', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', fontWeight:500 }}>
                            {DIAS[dia.data.getDay()]}
                          </div>
                          <div style={{ width:'40px', height:'40px', borderRadius:'50%', display:'inline-flex', alignItems:'center', justifyContent:'center', background: dia.isToday ? SEM_STATUS_TXT : 'transparent', color: dia.isToday ? 'white' : '#202124', fontSize:'22px', fontWeight: dia.isToday ? 700 : 400 }}>
                            {dia.data.getDate()}
                          </div>
                          {/* Mini-barra de status por dia */}
                          {ds.total > 0 && (
                            <div style={{ display:'flex', height:'3px', width:'40px', margin:'4px auto 2px', borderRadius:'2px', overflow:'hidden', gap:'1px' }}>
                              {ds.realizadas    > 0 && <div style={{ flex:ds.realizadas,    background:'#34a853' }} />}
                              {ds.faltas        > 0 && <div style={{ flex:ds.faltas,        background:'#ea4335' }} />}
                              {ds.cancelamentos > 0 && <div style={{ flex:ds.cancelamentos, background:'#fbbc04' }} />}
                              {ds.recuperacoes  > 0 && <div style={{ flex:ds.recuperacoes,  background:'#f09300' }} />}
                              {ds.sem           > 0 && <div style={{ flex:ds.sem,           background:SEM_STATUS_COR }} />}
                            </div>
                          )}
                          {/* % registrados */}
                          {ds.total > 0 && (
                            <div style={{ fontSize:'10px', color: pct === 100 ? '#0b8043' : '#9aa0a6', fontWeight: pct === 100 ? 700 : 400, lineHeight:1, marginTop:'1px' }}>
                              {pct}%
                            </div>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {horarios.map(hora => (
                    <tr key={hora}>
                      {/* coluna de hora sticky */}
                      <td style={{
                        position:'sticky', left:0, zIndex:1, background:'white',
                        padding:'4px 6px 0 4px', textAlign:'right', verticalAlign:'top',
                        fontSize:'11px', color:'#70757a', fontWeight:500, whiteSpace:'nowrap',
                        borderRight:'1px solid #e0e0e0', borderBottom:'1px solid #f1f3f4',
                      }}>
                        {hora}
                      </td>
                      {dias.map(dia => {
                        const alunos = grid[`${dia.key}_${hora}`] || [];
                        return (
                          <td key={dia.key} style={{ padding:'4px 3px', verticalAlign:'top', minHeight: isMobile ? '52px' : '48px', borderRight:'1px solid #e0e0e0', borderBottom:'1px solid #f1f3f4' }}>
                            {alunos.map(r => (
                              <EventoGrid key={`${r.vaga_id}_${r.aluno_id}`} r={r} onClick={setSelecionado} compacto={!isMobile && dias.length > 5} isSaving={!!salvando[`${r.vaga_id}_${r.aluno_id}`]} />
                            ))}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══ ABA RESUMO MENSAL ═══════════════════════════════════════════════════ */}
      {subAba === 'resumo' && (
        <div style={{ flex:1, overflow:'auto', padding: isMobile ? '12px 10px' : '20px 24px' }}>

          {/* Seletor mês/ano */}
          <div style={{ display:'flex', alignItems:'center', gap:'4px', marginBottom:'16px', background:'white', padding:'10px 14px', borderRadius:'12px', border:'1px solid #e0e0e0', flexWrap:'wrap' }}>
            <button onClick={() => navMes(-1)} style={{ width:'36px', height:'36px', borderRadius:'50%', border:'none', background:'none', color:'#70757a', fontSize:'16px', cursor:'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background='#f1f3f4'} onMouseLeave={e => e.currentTarget.style.background='none'}>◀</button>
            <span style={{ fontWeight:600, color:'#202124', fontSize:'16px', minWidth:'148px', textAlign:'center' }}>
              {MESES[mes - 1]} {ano}
            </span>
            <button onClick={() => navMes(+1)} style={{ width:'36px', height:'36px', borderRadius:'50%', border:'none', background:'none', color:'#70757a', fontSize:'16px', cursor:'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background='#f1f3f4'} onMouseLeave={e => e.currentTarget.style.background='none'}>▶</button>
            <button onClick={carregarResumo} disabled={loadingResumo} style={{ marginLeft:'auto', padding:'8px 22px', border:'none', borderRadius:'20px', background:SEM_STATUS_TXT, color:'white', fontWeight:600, fontSize:'14px', cursor:'pointer' }}>
              {loadingResumo ? '...' : 'Carregar'}
            </button>
          </div>

          {loadingResumo ? (
            <div style={{ textAlign:'center', padding:'60px', color:'#70757a' }}>⏳ Carregando...</div>
          ) : !resumo ? null : resumo.resumo.length === 0 ? (
            <div style={{ textAlign:'center', padding:'60px', color:'#70757a' }}>
              <div style={{ fontSize:'48px', marginBottom:'12px', opacity:0.25 }}>📊</div>
              <p style={{ fontSize:'16px' }}>Nenhum agendamento em {MESES[mes-1]} {ano}</p>
            </div>
          ) : isMobile ? (

            /* ── Resumo mobile: cards por aluno ── */
            <div>
              {resumo.resumo.map(r => {
                const registrados = (+r.realizadas) + (+r.faltas) + (+r.cancelamentos) + (+r.recuperacoes);
                const pct = +r.total_aulas > 0 ? Math.round(registrados / +r.total_aulas * 100) : 0;
                return (
                  <div key={r.aluno_id} style={{ background:'white', borderRadius:'14px', border:'1px solid #e0e0e0', padding:'14px 16px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'10px' }}>
                      <div>
                        <div style={{ fontWeight:700, color:'#202124', fontSize:'15px' }}>👤 {r.aluno_nome}</div>
                        <div style={{ fontSize:'11px', color:'#9aa0a6', marginTop:'2px' }}>{r.aluno_email}</div>
                      </div>
                      <span style={{ fontSize:'13px', fontWeight:700, color:'#202124', background:'#f1f3f4', padding:'4px 10px', borderRadius:'20px', flexShrink:0 }}>
                        {r.total_aulas} aulas
                      </span>
                    </div>

                    {/* Mini barra de progresso do mês */}
                    <div style={{ marginBottom:'10px' }}>
                      <div style={{ display:'flex', justifyContent:'space-between', fontSize:'11px', color:'#70757a', marginBottom:'4px' }}>
                        <span>{registrados}/{r.total_aulas} registradas</span>
                        <span style={{ fontWeight:700, color: pct === 100 ? '#0b8043' : SEM_STATUS_TXT }}>{pct}%</span>
                      </div>
                      <div style={{ height:'4px', background:'#f1f3f4', borderRadius:'2px', overflow:'hidden' }}>
                        <div style={{ height:'100%', width:`${pct}%`, borderRadius:'2px', background: pct === 100 ? '#34a853' : `linear-gradient(90deg,${SEM_STATUS_TXT},${SEM_STATUS_COR})`, transition:'width 0.4s ease' }} />
                      </div>
                    </div>

                    {/* Grid de contadores */}
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'6px' }}>
                      {[
                        { label:'Realizadas',    v:r.realizadas,    c:'#0b8043', bg:'#e6f4ea', icon:'✅' },
                        { label:'Faltas',        v:r.faltas,        c:'#c5221f', bg:'#fce8e6', icon:'❌' },
                        { label:'Cancelamentos', v:r.cancelamentos, c:'#e37400', bg:'#fef7e0', icon:'📅' },
                        { label:'Recuperações',  v:r.recuperacoes,  c:'#d56e0c', bg:'#fdebd0', icon:'🔄' },
                        { label:'Sem registro',  v:r.sem_registro,  c:SEM_STATUS_TXT, bg:SEM_STATUS_BG, icon:'⏳' },
                      ].map((cell, ci) => (
                        <div key={ci} style={{ textAlign:'center', padding:'8px 4px', borderRadius:'10px', background: +cell.v > 0 ? cell.bg : '#fafafa', border:`1px solid ${+cell.v > 0 ? cell.c + '30' : '#f1f3f4'}` }}>
                          <div style={{ fontSize:'10px', marginBottom:'2px' }}>{cell.icon}</div>
                          <div style={{ fontSize:'20px', fontWeight:800, color: +cell.v > 0 ? cell.c : '#dadce0', lineHeight:1 }}>{cell.v}</div>
                          <div style={{ fontSize:'9px', color: +cell.v > 0 ? cell.c : '#bdc1c6', fontWeight:600, marginTop:'2px', letterSpacing:'0.2px' }}>{cell.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}

              {/* Totais */}
              <div style={{ background:'#f8f9fa', borderRadius:'14px', border:'2px solid #e0e0e0', padding:'14px 16px', marginTop:'4px' }}>
                <div style={{ fontWeight:700, color:'#3c4043', fontSize:'14px', marginBottom:'10px' }}>
                  Total · {resumo.resumo.length} aluno{resumo.resumo.length !== 1 ? 's' : ''}
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'6px' }}>
                  {[
                    { label:'Realizadas',    k:'realizadas',    c:'#0b8043', bg:'#e6f4ea', icon:'✅' },
                    { label:'Faltas',        k:'faltas',        c:'#c5221f', bg:'#fce8e6', icon:'❌' },
                    { label:'Cancelamentos', k:'cancelamentos', c:'#e37400', bg:'#fef7e0', icon:'📅' },
                    { label:'Recuperações',  k:'recuperacoes',  c:'#d56e0c', bg:'#fdebd0', icon:'🔄' },
                    { label:'Sem registro',  k:'sem_registro',  c:SEM_STATUS_TXT, bg:SEM_STATUS_BG, icon:'⏳' },
                    { label:'Total',         k:'total_aulas',   c:'#202124', bg:'#f1f3f4', icon:'📋' },
                  ].map((cell, ci) => {
                    const total = resumo.resumo.reduce((s, r) => s + (+r[cell.k] || 0), 0);
                    return (
                      <div key={ci} style={{ textAlign:'center', padding:'8px 4px', borderRadius:'10px', background:cell.bg, border:`1px solid ${cell.c}30` }}>
                        <div style={{ fontSize:'10px', marginBottom:'2px' }}>{cell.icon}</div>
                        <div style={{ fontSize:'20px', fontWeight:800, color:cell.c, lineHeight:1 }}>{total}</div>
                        <div style={{ fontSize:'9px', color:cell.c, fontWeight:600, marginTop:'2px' }}>{cell.label}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

          ) : (

            /* ── Resumo desktop: tabela ── */
            <div style={{ background:'white', borderRadius:'12px', border:'1px solid #e0e0e0', overflow:'hidden' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ background:'#f8f9fa' }}>
                    {['Aluno','Total','✅ Realizadas','❌ Faltas','📅 Cancelamentos','🔄 Recuperações','⏳ Sem registro'].map((h, i) => (
                      <th key={i} style={{ padding:'13px 16px', textAlign: i === 0 ? 'left' : 'center', fontSize:'11px', fontWeight:600, color:'#5f6368', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #e0e0e0', whiteSpace:'nowrap' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {resumo.resumo.map((r, idx) => (
                    <tr key={r.aluno_id} style={{ background: idx % 2 === 0 ? 'white' : '#fafafa', borderBottom:'1px solid #f1f3f4' }}>
                      <td style={{ padding:'12px 16px' }}>
                        <div style={{ fontWeight:600, color:'#202124', fontSize:'14px' }}>{r.aluno_nome}</div>
                        <div style={{ fontSize:'11px', color:'#9aa0a6', marginTop:'1px' }}>{r.aluno_email}</div>
                      </td>
                      <td style={{ textAlign:'center', padding:'12px 8px', fontWeight:700, color:'#202124', fontSize:'15px' }}>{r.total_aulas}</td>
                      {[
                        { v:r.realizadas,    c:'#0b8043', bg:'#e6f4ea' },
                        { v:r.faltas,        c:'#c5221f', bg:'#fce8e6' },
                        { v:r.cancelamentos, c:'#e37400', bg:'#fef7e0' },
                        { v:r.recuperacoes,  c:'#d56e0c', bg:'#fdebd0' },
                        { v:r.sem_registro,  c:SEM_STATUS_TXT, bg:SEM_STATUS_BG },
                      ].map((cell, ci) => (
                        <td key={ci} style={{ textAlign:'center', padding:'12px 8px' }}>
                          <span style={{ display:'inline-block', minWidth:'28px', padding:'3px 10px', borderRadius:'12px', fontSize:'14px', fontWeight:700, color: +cell.v > 0 ? cell.c : '#dadce0', background: +cell.v > 0 ? cell.bg : 'transparent' }}>
                            {cell.v}
                          </span>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background:'#f8f9fa', borderTop:'2px solid #e0e0e0' }}>
                    <td style={{ padding:'12px 16px', fontWeight:700, color:'#3c4043', fontSize:'13px' }}>
                      Total · {resumo.resumo.length} aluno{resumo.resumo.length !== 1 ? 's' : ''}
                    </td>
                    {['total_aulas','realizadas','faltas','cancelamentos','recuperacoes','sem_registro'].map(k => (
                      <td key={k} style={{ textAlign:'center', padding:'12px 8px', fontWeight:800, color:'#202124', fontSize:'15px' }}>
                        {resumo.resumo.reduce((s, r) => s + (+r[k] || 0), 0)}
                      </td>
                    ))}
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
